import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';

export const Testimonials = () => {
  const testimonials = [
    {
      name: 'Adrien Marchand',
      role: 'Demo User',
      content: 'The interface is incredibly smooth. The wheel animation feels just like a real premium casino experience, without the risk of real money.',
      rating: 5
    },
    {
      name: 'Sofia Bellini',
      role: 'Demo User',
      content: 'Beautifully designed. The dark mode with gold accents gives it a very luxurious feel. The chip selector is very intuitive to use.',
      rating: 5
    },
    {
      name: 'Marcus Reed',
      role: 'Demo User',
      content: 'I love how responsive it is on mobile. Testing different betting patterns with the virtual credits is a lot of fun and educational.',
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-charcoal-800">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-bold text-white mb-4"
          >
            What Players <span className="text-gold-500">Say</span>
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-3 py-1 bg-charcoal-900 border border-gray-700 rounded-full"
          >
            <span className="text-[10px] font-bold tracking-widest text-gray-400">SAMPLE FEEDBACK</span>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="bg-charcoal-900 p-8 rounded-2xl border border-gray-800 relative group hover:border-gold-500/30 transition-colors"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gray-800 group-hover:text-gold-900/20 transition-colors" />
              
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-gold-500 text-gold-500" />
                ))}
              </div>
              
              <p className="text-gray-300 leading-relaxed mb-8 relative z-10 italic">
                "{testimonial.content}"
              </p>
              
              <div className="flex items-center gap-4 border-t border-gray-800 pt-6">
                <div className="w-10 h-10 rounded-full bg-charcoal-800 flex items-center justify-center border border-gray-700 font-bold text-gold-500">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="text-white font-bold text-sm">{testimonial.name}</h4>
                  <p className="text-gray-500 text-xs">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
